const VERSION = "2.0.2";
const STORAGE_PREFIX = `_ccfs_${VERSION}`;
const CONSENT_DATA_STORAGE_NAME = `${STORAGE_PREFIX}_consent`;
const NOTIFICATION_STORAGE_NAME = `${STORAGE_PREFIX}_notifications`;
const SDK_BID = "pns_consent_system";
var Region = /* @__PURE__ */ ((Region2) => {
  Region2["US_EAST"] = "US-East";
  Region2["US_EASTRED"] = "US-EastRed";
  Region2["SINGAPORE_CENTRAL"] = "Singapore-Central";
  Region2["EU_TTP"] = "EU-TTP";
  Region2["EU_TTP2"] = "EU-TTP2";
  Region2["US_TTP"] = "US-TTP";
  Region2["US_TTP2"] = "US-TTP2";
  return Region2;
})(Region || {});
var Mode = /* @__PURE__ */ ((Mode2) => {
  Mode2["PRODUCTION"] = "production";
  Mode2["DEV"] = "dev";
  Mode2["BOE"] = "boe";
  return Mode2;
})(Mode || {});
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["UNSUPPORTED"] = "Unsupported";
  Platform2["WEB"] = "Web";
  Platform2["ANDROID"] = "Android";
  Platform2["IOS"] = "IOS";
  Platform2["PC_MAC"] = "PC_MAC";
  Platform2["PC_WINDOWS"] = "PC_WINDOWS";
  return Platform2;
})(Platform || {});
export {
  CONSENT_DATA_STORAGE_NAME,
  Mode,
  NOTIFICATION_STORAGE_NAME,
  Platform,
  Region,
  SDK_BID,
  STORAGE_PREFIX,
  VERSION
};
